import { useMemo } from 'react';
import classNames from 'classnames/bind';
import styles from './Select.module.css';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { useSlice } from '../../../hooks/useSlice';

import Button from '../../Button';
import Icon from '../../Icon';
import { SELECT } from '../../../constants';

interface Select {
  type: 'grid' | 'list';
  projectId: number;
}

export default function Select({ type, projectId }: Select) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const { itemSelected, selectSelectedIds } = useSlice();

  const selectedIds = useAppSelector(selectSelectedIds);

  const ids = useMemo(() => [...selectedIds], [selectedIds]);
  const isSelected = ids.includes(projectId);

  const selectItem = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    const idx = ids.indexOf(projectId);
    idx === -1 ? ids.push(projectId) : ids.splice(idx, 1);
    dispatch(itemSelected({ ids }));
  };

  return (
    <div className={cx('check_area', type)}>
      <Button
        name={SELECT}
        classnames={['items_edit_check', type, { on: isSelected }]}
        isBlindName={true}
        handleClick={selectItem}
      >
        <Icon name="bookSelect" />
      </Button>
    </div>
  );
}
